export const   fetch= 'FETCH-USER'
export const   set= 'SET-USER'
export const   error= 'FETCHING-ERROR-USER'

